<template>
    <div class="picture-item">
    <div class="item-controls text-center c_actions_layer">
      <div onclick="stop_bubble(event); event.preventDefault();" style="display: inline-block">
        <div v-on:click="toggleLikeWork($event, work.uri)"
             v-bind:class="[this.likes['is_liked'] ? 'active' : '']"
             class="item-control icon-heart c_like_selector"
             :title="this.likes['is_liked'] ? $t('message.MeLiked') : $t('message.Like')">
          {{this.likes['count']}}
        </div>
        <div class="rel item-control pointer" style="padding: 0">

          <div class="c_ui5_select dropdown" style="width: 100%;height: 100%;"
               data-isopentoup="0" data-diftop="10"
               data-onshow="action_set.show_add_to_selection(j_obj, j_cont);" data-multyselect="0" data-setcaption="1" data-setactive="1" data-name="">

            <div class="icon-to-collection" style="width: 100%;height: 100%;padding-top: 12px;"
                 onclick="model_ui5.drop_down(this, event); event.preventDefault();" :title="$t('message.AddToSelection')"/>

            <div class="dropdown__list-container dropdown__list-container__nomax" style="max-width:300px; text-align: left">
              <div class="dropdown-list cjs_dropdown_list">
                <div class="dropdown-list__wrapper" style="max-height: none">
                  <div style="max-height: 300px; overflow: hidden">
                    <div :id="'id_selection_scroll_'+work.work_id" class="custom-scroll">
                      <div class="dropdown-list__item" onclick="stop_bubble(event)" style="cursor: auto">
                        <div class="dropdown-list__item-text dropdown-list__item-text_14-20">

                          <!-- см. _m_sets_action_add_to_selection_list -->
                          <form onsubmit="return false;">
                            <div class="input input_size-40 input_animate-label c_ui5_inp_cont" style="width: 194px; float: left; margin-right: 10px;">
                              <label class="input__label">
                                <input class="input__input-field c_ui5_inp cjs_inp" style="background-color: #fff"/>
                                <span class="input__label-span">
                                  {{ $t('message.newSelection') }}
                                </span>
                              </label>
                            </div>

                            <button class="button-default button-default_size-40 pointer" :onclick="addToSetClick">
                              <div class="svg-icon svg-icon_size-14px">
                                <svg width="14" height="14" viewBox="0 0 14 14"><path class="svg-icon__path" fill-rule="evenodd" d="M8 6h6v2H8v6H6V8H0V6h6V0h2v6z"></path></svg>
                              </div>
                            </button>
                          </form>

                        </div>
                      </div>
                      <div class="dropdown-list__item c_loading" :data-workid="work.work_id" style="cursor: auto">
                        <div class="dropdown-list__item-text dropdown-list__item-text_14-20">
                          <div class="c_loading_maked c_spinner_cont">
                            <img alt="" class="c_spinner" src="/res/img/svg/spinner-black.svg"><!-- window._GL_SITE_URL_CDN -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="work.can_i_nomod === 'y'" class="item-control pointer c_spinner_white" v-on:click="qpromoWork($event)" :title="$t('message.AdvWork')">
          <div class="icon-up c_need_parent"/>
        </div>

        <div v-on:click="toggleMenu($event)"
             v-bind:data-workid="work.work_id"
             class="rel c_show_submenu_container item-control pointer c_block"
        >
          <div data-url="save"
               style="height: 100%; margin-top: -1px;"
               class="icon-cog"
          ></div>
          <span class="c_dotted_more"
                data-id="">
            </span>
        </div>

        <div v-bind:class="[showMenu ? 'active' : 'none']"
             v-bind:id="'id_popup_dotted_more_idm_c_' + work.work_id"
             class="dotted_more c_add_to_set item-controls-menu">
          <ul>
            <li v-if="work.can_i === 'y'" v-on:click="editData($event)">
              <span class="pointer">{{ $t("message.EditData") }}</span>
            </li>

            <li v-if="work.can_i === 'y'" v-on:click="removeWork($event)">
              <span class="pointer">{{ $t("message.RemoveWork") }}</span>
            </li>

            <li v-if="work.can_i !== 'y'" v-on:click="toggleComplaint($event)" class="rel c_complaint">
              <span class="pointer">{{ $t("message.complaint") }}</span>
              <div v-bind:class="[showComplaint ? 'active' : 'none']"
                   class="modal-layer modal-layer-complaint c_add_to_set c_complaint_popup">
                <ul>
                  <li>
                    <a v-on:click="sendComplaint(1, $event)" class="pointer">
                      {{ $t("message.copyright") }}
                    </a>
                  </li>
                  <li v-on:click="sendComplaint(2, $event)">
                    <a class="pointer">
                      {{ $t("message.badPicture") }}
                    </a>
                  </li>
                  <li v-on:click="sendComplaint(3, $event)">
                    <a class="pointer">
                      {{ $t("message.badInfo") }}
                    </a>
                  </li>
                  <li v-on:click="sendComplaint(4, $event)">
                    <a class="pointer">
                      {{ $t("message.badWords") }}
                    </a>
                  </li>
                  <li v-on:click="sendComplaint(5, $event)">
                    <a class="pointer">
                      <span class="icon-attention-circled pull-right"></span>
                      {{ $t("message.spam") }}
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
		</div>
</template>

<script>
  import WorksItemControlsMix from './WorksItemControlsMix'

  export default {
    name    : 'works-item-controls',
    mixins: [WorksItemControlsMix],

    created(){
      this.$nextTick(function(){
        setTimeout( ()=>{
          window.global.init_scrollbar_lq('#id_selection_scroll_'+this.work.work_id, {}, '300px', '');
        }, 100 );
      })
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/list/WorksItemControls.vue